import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const AboutPage = () => {
  const boardMembers = [
    {
      name: "Eldina James Lugaganya",
      role: "Chairperson",
      country: "Tanzania",
      image: "/team/eldina.png"
    },
    {
      name: "Catherine Kushoka Lugaganya",
      role: "Treasurer",
      country: "Tanzania",
      image: "/team/catherine.png"
    },
    {
      name: "Gwamaka Mwakijungu Israel",
      role: "Secretary",
      country: "Tanzania",
      image: "/team/gwamaka.png"
    },
    {
      name: "Modesta James Lugaganya",
      role: "Member",
      country: "Tanzania",
      image: "/team/modesta.png"
    },
    {
      name: "Sundi James Lugaganya",
      role: "Member",
      country: "Tanzania",
      image: "/team/sundy1.png"
    },
    {
      name: "Restituta James Lugaganya",
      role: "Member",
      country: "Tanzania",
      image: "/team/resty.png"
    }
  ];

  const staffMembers = [
    {
      name: "Eldina James Lugaganya",
      role: "Executive Director",
      country: "Tanzania",
      image: "/team/eldina.png"
    },
    {
      name: "Margaret Alfred Mwapinga",
      role: "Finance Manager",
      country: "Tanzania",
      image: "/team/Margaret.jpg"
    },{
      name: "Sundi James Lugaganya",
      role: "Program Manager",
      country: "Tanzania",
      image: "/team/sundy1.png"
    }
  ];

  const focusAreas = [
    {
      letter: "A",
      title: "Education and Awareness",
      description: "We conduct community education programs and awareness campaigns that provide individuals with knowledge and information needed to make informed decisions about their health, rights, and opportunities.",
      icon: "📚"
    },
    {
      letter: "B",
      title: "Mental Health Awareness",
      description: "CAEI promotes understanding and awareness of mental health issues within communities. Through workshops, discussions, and outreach programs, we aim to reduce stigma and encourage access to support services.",
      icon: "🧠"
    },
    {
      letter: "C",
      title: "Combating Violence in Society",
      description: "The organization advocates for the prevention of violence in all its forms by raising awareness, supporting survivors, and promoting human rights and dignity for all members of society.",
      icon: "🛡️"
    },
    {
      letter: "D",
      title: "Empowering Adolescents Through Education",
      description: "CAEI works to support adolescents by providing educational support, mentorship, and life-skills training that prepares them for responsible and productive futures.",
      icon: "🌱"
    },
    {
      letter: "E",
      title: "Youth Empowerment",
      description: "We promote youth development by supporting leadership training, entrepreneurship skills, and opportunities that enable young people to contribute positively to society.",
      icon: "🚀"
    },
    {
      letter: "F",
      title: "Capacity Building",
      description: "CAEI strengthens the abilities of individuals, community groups, and organizations through training, skills development, and knowledge sharing to enhance sustainable community development.",
      icon: "💪"
    }
  ];

  return (
    <div className="about-page">
      {/* Page Header */}
      <div className="page-header">
        <div className="page-header-overlay"></div>
        <div className="container">
          <div className="page-header-content">
            <div className="page-badge">About CAEI</div>
            <h1 className="page-title-animated">Community Awareness and Empowerment Initiative</h1>
            <p className="page-subtitle">
              Supporting survivors of violence through free counseling, psychosocial support, and community education
            </p>
            <div className="page-stats">
              <div className="stat-item">
                <div className="stat-icon">🎯</div>
                <div className="stat-number">6</div>
                <div className="stat-label">Focus Areas</div>
              </div>
              <div className="stat-item">
                <div className="stat-icon">👥</div>
                <div className="stat-number">10+</div>
                <div className="stat-label">Team Members</div>
              </div>
              <div className="stat-item">
                <div className="stat-icon">🤝</div>
                <div className="stat-number">6+</div>
                <div className="stat-label">Partners</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container page-content">
        {/* ORGANIZATION OVERVIEW */}
        <section className="about-section organization-overview">
          <div className="overview-content">
            <h2 className="overview-title">Who We Are</h2>
            <div className="overview-text">
              <p>
                Community Awareness and Empowerment Initiative (CAEI) is a community-based organization committed to supporting survivors of violence through free counseling, psychosocial support, and community education.
              </p>
              <p>
                We work to promote healing, strengthen community support systems, and reduce stigma around mental health so that survivors can rebuild their lives with dignity and hope.
              </p>
              <p>
                Through collaboration with communities and partners, we strive to create safer environments where survivors are supported, respected, and given the opportunity to thrive.
              </p>
              <p className="highlight-text">
                CAEI currently operates in Dar es Salaam and aims to expand services to other regions of Tanzania in the future.
              </p>
            </div>
          </div>
        </section>

        {/* FOUNDER STORY */}
        <section className="about-section founder-section">
          <div className="section-header-modern">
            <div>
              <h2 className="section-title-numbered">Founder's Story</h2>
              <p className="section-description">
                A journey from pain to purpose
              </p>
            </div>
          </div>
          <div className="founder-content">
            <div className="founder-story">
              <p>
                Eldina James Lugaganya founded CAEI after experiencing intimate partner violence in her own marriage. Living with a toxic partner left deep emotional wounds, but through counseling and support, she found healing and strength.
              </p>
              <p>
                Her journey inspired her to create CAEI, providing free and confidential support for survivors of violence, empowering them to heal, regain confidence, and rebuild their lives with dignity.
              </p>
              <p className="highlight-text">
                Eldina's story is proof that healing is possible—and no survivor should face their pain alone.
              </p>
            </div>
          </div>
        </section>

        {/* OUR BOARD */}
        <section className="about-section" id="board">
          <div className="section-header-modern">
            <span className="section-number">1.</span>
            <div>
              <h2 className="section-title-numbered">Our Board</h2>
              <p className="section-description">
                The Board of CAEI provides strategic leadership, governance, and oversight to ensure that the organization operates with integrity, transparency, and accountability. Board members bring diverse experience from fields such as community development, education, public health, and social advocacy. Their role is to guide the organization's long-term vision, support effective program implementation, and ensure that CAEI remains focused on achieving meaningful and sustainable impact within communities.
              </p>
            </div>
          </div>
          <div className="team-grid">
            {boardMembers.map((member, index) => (
              <div className="team-member-card" key={index}>
                <div className="member-image-wrapper">
                  <img src={member.image} alt={member.name} />
                  <div className="member-overlay">
                    <div className="member-role-badge">{member.role}</div>
                  </div>
                </div>
                <div className="member-details">
                  <h3 className="member-name">{member.name}</h3>
                  <div className="member-position">{member.role}</div>
                  <div className="member-location">
                    <span className="location-icon">📍</span>
                    <span>{member.country}</span>
                  </div>
                  {member.name === "Eldina James Lugaganya" && member.role === "Chairperson" && (
                    <div className="founder-quote">
                      <p>"Healing gave me back my voice, my journey from pain to healing taught me one powerful truth: no survivor should have to face violence or trauma alone."</p>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* STAFF TEAM */}
        <section className="about-section" id="staff">
          <div className="section-header-modern">
            <span className="section-number">2.</span>
            <div>
              <h2 className="section-title-numbered">Staff Team</h2>
              <p className="section-description">
                The CAEI Staff Team consists of dedicated professionals and volunteers who work tirelessly to implement the organization's programs and initiatives. Our team includes individuals with expertise in community development, education, social work, and youth engagement. Together, they coordinate projects, conduct training and awareness programs, and work closely with community members to ensure that CAEI's initiatives address real needs and produce lasting impact. Through teamwork, commitment, and community collaboration, the staff team plays a critical role in advancing the mission and vision of CAEI.
              </p>
            </div>
          </div>
          <div className="team-grid staff-grid">
            {staffMembers.map((member, index) => (
              <div className="team-member-card" key={index}>
                <div className="member-image-wrapper">
                  <img src={member.image} alt={member.name} />
                  <div className="member-overlay">
                    <div className="member-role-badge">{member.role}</div>
                  </div>
                </div>
                <div className="member-details">
                  <h3 className="member-name">{member.name}</h3>
                  <div className="member-position">{member.role}</div>
                  <div className="member-location">
                    <span className="location-icon">📍</span>
                    <span>{member.country}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* FOCUS AREAS */}
        <section className="about-section focus-areas-section" id="focus-areas">
          <div className="section-header-modern">
            <span className="section-number">3.</span>
            <div>
              <h2 className="section-title-numbered">Focus Areas</h2>
              <p className="section-description">
                CAEI focuses on key development areas that address social challenges and promote community empowerment.
              </p>
            </div>
          </div>
          <div className="focus-areas-list">
            {focusAreas.map((area, index) => (
              <div className="focus-area-item" key={index}>
                <div className="focus-area-header">
                  <span className="focus-area-letter-large">{area.letter}</span>
                  <span className="focus-area-icon-large">{area.icon}</span>
                  <h3 className="focus-area-heading">{area.title}</h3>
                </div>
                <p className="focus-area-text">{area.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* OUR PARTNERS */}
        <section className="about-section partners-section" id="partners">
          <div className="section-header-modern">
            <span className="section-number">4.</span>
            <div>
              <h2 className="section-title-numbered">Our Partners</h2>
              <p className="section-description">Collaborating with organizations that share our vision</p>
            </div>
          </div>
          {/*<div className="partners-grid">*/}
          {/*  <div className="partner-logo-wrapper">*/}
          {/*    <img src="/partners/partner1.png" alt="Partner 1" className="partner-logo" />*/}
          {/*  </div>*/}
          {/*  <div className="partner-logo-wrapper">*/}
          {/*    <img src="/partners/partner2.png" alt="Partner 2" className="partner-logo" />*/}
          {/*  </div>*/}
          {/*  <div className="partner-logo-wrapper">*/}
          {/*    <img src="/partners/partner3.png" alt="Partner 3" className="partner-logo" />*/}
          {/*  </div>*/}
          {/*  <div className="partner-logo-wrapper">*/}
          {/*    <img src="/partners/partner4.png" alt="Partner 4" className="partner-logo" />*/}
          {/*  </div>*/}
          {/*  <div className="partner-logo-wrapper">*/}
          {/*    <img src="/partners/partner5.png" alt="Partner 5" className="partner-logo" />*/}
          {/*  </div>*/}
          {/*  <div className="partner-logo-wrapper">*/}
          {/*    <img src="/partners/partner6.png" alt="Partner 6" className="partner-logo" />*/}
          {/*  </div>*/}
          {/*</div>*/}
        </section>

        {/* Back to Home */}
        <div className="page-nav-footer">
          <Link to="/" className="btn btn-primary">← Back to Home</Link>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AboutPage;
